export default __webpack_public_path__ + "static/media/Armbands of the Death God.9687820e.jpg";